import { SearchState } from '@/types/models'
import {
  isNonEmptyObject,
  isNonEmptyArray,
  isNonEmptyString
} from '@/utils/checks'
import { FACETS_TO_BOOST } from '@/domain/useCases/score/constants'

export const getSpecializationsFromSearchState = ({
  searchState,
  specializationBoost
}: {
  searchState: SearchState['refinementList']
  specializationBoost: number
}): string[] => {
  if (!isNonEmptyObject(searchState)) {
    return []
  }

  const specializationFilters = generateSpecializationFilters(searchState)

  if (specializationFilters.length === 0) {
    return []
  }
  const derivedBoost = (
    specializationBoost / specializationFilters.length
  ).toFixed(0)

  return specializationFilters.map((filter) => {
    return filter.concat(`<score=${derivedBoost}>`)
  })
}

export const generateSpecializationFilters = (
  searchState: SearchState['refinementList']
): string[] => {
  if (!isNonEmptyObject(searchState)) {
    return []
  }
  return Object.entries(searchState).reduce((acc: string[], [facet, value]) => {
    if (isNonEmptyArray(value) && FACETS_TO_BOOST.includes(facet)) {
      return [...acc, ...value.map((term) => `new_specializations:${term}`)]
    }
    if (isNonEmptyString(value) && FACETS_TO_BOOST.includes(facet)) {
      return [...acc, `new_specializations:${value}`]
    }

    return acc
  }, [])
}
